<script setup lang="ts">
import GhostButton from '@/components/common/GhostButton.vue';
import ModalDialog from '@/components/common/ModalDialog.vue';
import PrimaryButton from '@/components/common/PrimaryButton.vue';

interface Props {
  static?: boolean;
}

withDefaults(defineProps<Props>(), {
  static: false,
});

const router = useRouter();
const emit = defineEmits<{
  confirm: [void];
  cancel: [void];
}>();

const { t } = useTranslations();

const open = defineModel<boolean>({ required: true });

const { whatsappLink } = useSupportWhatsappLink();

function onConfirmHandler() {
  router.push({ name: 'CartSelectView' });
  emit('confirm');
}

function onCancelHandler() {
  emit('cancel');
}
</script>

<template>
  <ModalDialog
    size="lg"
    v-model="open"
    contentClass="text-center"
    :static="static"
    @close="open = false"
  >
    <div data-testid="select-plan-dialog" class="flex flex-col items-center space-y-4">
      <img class="w-full max-w-52" src="/images/cleepo/cleepo_beneficios_1.png" alt="Cleepo" />
      <h3 class="text-2xl">{{ t('cleepo.domain.select_plan_modal.title') }}</h3>
      <p>{{ t('cleepo.domain.select_plan_modal.description') }}</p>
      <div class="!mt-8 w-full space-y-2">
        <div>
          <router-link :to="{ name: 'CartSelectView' }" @click="onConfirmHandler">
            <PrimaryButton class="w-full">
              {{ t('cleepo.domain.select_plan_modal.confirm') }}
            </PrimaryButton>
          </router-link>
        </div>
        <div>
          <a :href="whatsappLink" @click="onCancelHandler" target="_blank">
            <GhostButton class="w-full">{{
              t('cleepo.domain.select_plan_modal.cancel')
            }}</GhostButton>
          </a>
        </div>
      </div>
    </div>
  </ModalDialog>
</template>

<style scoped lang="scss"></style>
